import React, {Component} from 'react'
import ClaimList from "./ClaimList";

export default class MedicalTouristClaimList extends Component {

    render() {
        return <ClaimList {...this.props} listParams={{medicalTourist: true}}/>;
    }
}
